const getCurrentConnectionType = ()=>{
    const connection = "u" > typeof window && window.navigator ? window.navigator.connection || window.navigator.mozConnection || window.navigator.webkitConnection : void 0;
    return connection?.effectiveType;
};
const src_getCurrentConnectionType = getCurrentConnectionType;
export default src_getCurrentConnectionType;
